(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/casino-store/prescript.js') >= 0) return;  svs.modules.push('/components/casino-react/casino-store/prescript.js');

svs = svs || {};
svs.casino_react = svs.casino_react || {};
svs.casino_react.shared = svs.casino_react.shared || {};
svs.casino_react.shared.data = svs.casino_react.shared.data || {};

svs.components = svs.components || {};
svs.components.casino = svs.components.casino || {};
svs.components.casino.data = svs.components.casino.data || {};

svs.components.casino_react = svs.components.casino_react || {};
svs.components.casino_react.casinoStore = svs.components.casino_react.casinoStore || {};
svs.components.casino_react.casinoStore.utils = svs.components.casino_react.casinoStore.utils || {};


 })(window);